export const REQUIRED_FIELD = 'Campo obligatorio';
export const MAIL_ERROR = 'Email no válido';
export const PHONE_ERROR = 'Teléfono no válido';
export const POLICY_REQUIRED = 'Tiene que aceptar las condiciones';

export const DOCUMENT_VALID_CHARS = 'TRWAGMYFPDXBNJZSQVHLCKET';
export const DOCUMENT_INITIAL_CHARS = {
  'X': '0',
  'Y': '1',
  'Z': '2'
};

export const DOCUMENT_VALIDATION = {
  MIN: 'Mínimo 6 dígitos',
  MAX: 'Máximo 25 dígitos',
  NIE: 'Número de documento NIE no válido',
  NIF: 'Número de documento NIF no válido',
  PASSPORT: 'Número de pasaporte no válido',

}

export const TIPO_DOC_ENUM = {
    NIF: 'NIF',
    NIE: 'NIE',
    PASSPORT: 'PASSPORT'
  }